import { render, staticRenderFns } from "./BasketMapGTable.vue?vue&type=template&id=33c7a829"
import script from "./BasketMapGTable.vue?vue&type=script&lang=js"
export * from "./BasketMapGTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports